'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "What is the difference between UX and UI design?",
    answer: "UX (User Experience) focuses on the overall usability and functionality of a product, while UI (User Interface) deals with the visual elements like layout, colors, buttons, and typography. Both work together to create a smooth and engaging experience for your users."
  },
  {
    question: "Why is good UX/UI design important for my business?",
    answer: "Effective UX/UI design improves user satisfaction, increases engagement, and drives conversions. A well-designed interface makes it easier for users to navigate, understand, and interact with your product or website — leading to better results."
  },
  {
    question: "What does your UX/UI design process include?",
    answer: "Our process includes research, wireframing, prototyping, visual design, user testing, and revisions. We ensure that every design decision is based on data, user behavior, and your business goals."
  },
  {
    question: "Can you redesign my existing website or app?",
    answer: "Yes, we offer redesign services for websites, mobile apps, and software platforms. We analyze the current user experience, identify pain points, and deliver a modern, optimized design that enhances performance."
  },
  {
    question: "Will the design be responsive and developer-friendly?",
    answer: "Absolutely. We create responsive designs that work seamlessly across devices and ensure that our design files are organized and ready for development — making collaboration smooth for your dev team."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div
        className="col text-center py-5 mt-5"
        data-aos="fade-up"
        data-aos-delay="100"
        data-aos-duration="500"
        data-aos-once="true"
      >
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div
          className="container"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="500"
          data-aos-once="true"
        >
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level={3}
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                   <span
  className={`transition-colors duration-200 cursor-pointer 
    hover:text-purple-600 
    ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
>{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
